import { useState, useEffect } from "react";
import Footer from "../Footer";
import Navbar from "../Header";
import SearchBar from "../SearchBar/SearchBar";
import { useLocation, useNavigate } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faLocationDot } from "@fortawesome/free-solid-svg-icons";
import BannerImg from "../../assets/aboutbanner2.jpeg";
import HeroSection from "../Home/HeroSection";
import { slugify } from '../../utils/slugify';

export default function SearchResults() {
  const [searchResult, setSearchResult] = useState("");

  const { state } = useLocation();
  const { data } = state;
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  // const [searchParams] = useSearchParams();
  // const city = searchParams.get('city');
  const navigate = useNavigate();
  // const options = [
  //   "Al Barari",
  //   "Al Barsha",
  //   "Al Furjan",
  //   "Al Habtoor City",
  //   "Al Hamra Village",
  //   "Al Jaddaff",
  //   "Al Jurf",
  //   "Al Kifaf",
  //   "Al Marjan Island",
  //   "Al Reem Island",
  //   "Al Safa",
  //   "Al Sufouh",
  //   "Al Wasl",
  //   "Al Zorah",
  //   "Arabian Ranches",
  //   "Arabian Ranches 2",
  //   "Arabian Ranches 3",
  //   "Arjan",
  //   "Bluewaters Island",
  //   "Burj Khalifa District",
  //   "Business Bay",
  //   "City Walk",
  //   "Culture Village",
  //   "DIFC",
  //   "Deira",
  //   "Downtown Dubai",
  //   "Downtown Jebel Ali",
  //   "Dubai Canal",
  //   "Dubai Creek Harbour",
  //   "Dubai Festival City",
  //   "Dubai Healthcare City",
  //   "Dubai Hills Estate",
  //   "Dubai Investment Park",
  //   "Dubai Islands",
  //   "Dubai Marina",
  //   "Dubai Production City",
  //   "Dubai Silicon Oasis",
  //   "Dubai South",
  //   "Dubai Sports City",
  //   "Dubailand",
  //   "Emaar Beachfront",
  //   "Emaar South",
  //   "Emirates Hills",
  //   "Emirates Living",
  //   "Expo City Dubai",
  //   "Falconcity",
  //   "Hudayriyat Island",
  //   "International City",
  //   "JBR",
  //   "Jebel Ali",
  //   "Jebel Ali Village",
  //   "Jumeira Bay",
  //   "Jumeirah",
  //   "Jumeirah Golf Estate",
  //   "Jumeirah Height",
  //   "Jumeirah Islands",
  //   "Jumeirah Lake Towers",
  //   "Jumeirah Park",
  //   "Jumeirah Village Circle",
  //   "Jumeirah Village Triangle",
  //   "MBR City",
  //   "Madinat Badr",
  //   "Madinat Jumeirah Living",
  //   "Majan",
  //   "Marine Drive",
  //   "Meadows",
  //   "Meydan City",
  //   "Mirdif Hills",
  //   "Motor City",
  //   "Mudon",
  //   "Muscat Bay",
  //   "Nad Al Hammar",
  //   "Nad Al Sheba",
  //   "Palm Jebel Ali",
  //   "Palm Jumeirah",
  //   "Pearl Jumeirah",
  //   "Port De La Mer",
  //   "Remraam",
  //   "Sheikh Zayed Road",
  //   "Sobha Hartland",
  //   "Springs",
  //   "Studio City",
  //   "The Lakes",
  //   "The Opera District",
  //   "The Valley",
  //   "The Views",
  //   "Tilal Al Ghaf",
  //   "Town Square",
  //   "Umm Suqeim",
  //   "Villanova",
  //   "Yas Bay",
  //   "Zaabeel",
  // ];

  return (
    <>
      <Navbar diffHeader={true} />
      {/* <div className="relative h-[65vh] flex overflow-hidden">
        <SearchBar
          setSearchResult={setSearchResult}
          searchResult={searchResult}
          options={options}
          customClasses={"mt-[15vh] mb-[2vh] z-10"}
        />
        <div className="absolute top-0 left-0 z-10 w-full h-full bg-black opacity-20"></div>
        <div className="absolute z-0 w-full h-full top-10">
          <img className="w-full h-full " src={BannerImg} alt="" />
        </div>
      </div> */}
      <HeroSection />

      <section className="w-full h-full px-4 md:px-16 my-[2.5rem] md:my-[5.5rem]">
        <h1 className="mb-2 font-sans text-lg font-medium text-left md:text-xl">
          Properties for sale in Dubai
        </h1>
        <p className="mb-4 text-sm text-left">{data.length || "No"} results</p>
        <div className="grid grid-cols-1 md:grid-cols-4 gap-x-2 gap-y-8">
          {data.map((property) => (
            <div
              key={property._id}
              className="w-[90vw]  md:max-w-72 overflow-hidden shadow-md rounded-lg"
            >
              <div
                className="group h-54 md:h-72"
                onClick={() => {
                  window.scrollTo(0, 0);
                  navigate(`/property/${slugify(property.name)}`);
                }}
              >
                <img
                  className="object-cover w-full h-full transition-transform duration-500 ease-in-out transform cursor-pointer group-hover:scale-105"
                  src={property.images[0]}
                  alt="property-img"
                />
              </div>
              <div className="p-3 mt-2">
                <p className="text-lg font-semibold text-left text-black font-poppins">
                  {property.name}
                </p>
                <div className="flex items-center justify-between mt-1">
                  <span className="flex items-center gap-2 text-sm text-gray-500 justify-left font-poppins ">
                    <FontAwesomeIcon icon={faLocationDot} className="" />
                    {property.location}
                  </span>
                  <p className="text-[#173d73] font-poppins font-semibold text-lg">
                    {property?.price > 0 ? property?.price + " AED" : ""}
                  </p>
                </div>
                <p className="text-left font-poppins flex items-center cursor-pointer hover:bg-[#173d73] hover:text-white transition-all duration-500  justify-center py-1 text-[#173d73] border border-[#173d73] rounded-md mt-4">
                  {"Contact Us"}
                </p>
              </div>
            </div>
          ))}
        </div>
      </section>
      <Footer />
    </>
  );
}
